import { applyMiddleware, compose, createStore } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { rootReducer } from './reducers'
import { rootEpics } from './epics'
import { ActionTypes, RootState } from './types'
import services from '../services'
import { getCookie } from '../utils'
import { getAppContextInstance } from '../components/Context'

const DEVTOOLS_EXTENSION = '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'
type WindowWithDevTools = Window & {
  [DEVTOOLS_EXTENSION]?: typeof compose
}
const composeEnhancers =
  ((process.env.NODE_ENV !== 'production' || getCookie(`${process.env.REACT_APP_SECRET_REDUX_COOKIE}`)) &&
    (window as WindowWithDevTools)[DEVTOOLS_EXTENSION]) ||
  compose

const epicMiddleware = createEpicMiddleware<ActionTypes, ActionTypes, RootState>({
  dependencies: { ...services, appContext: getAppContextInstance },
})

function configureStore() {
  return createStore(rootReducer, composeEnhancers(applyMiddleware(epicMiddleware)))
}

const store = configureStore()

epicMiddleware.run(rootEpics)
export default store
